export default __webpack_public_path__ + "static/media/big_cube.0c899e7a.svg";